import { Component, OnInit } from '@angular/core';
import { CustomerManageOrdersService } from '../../../service/cutomer-manage-order.service';
import swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { HelperService } from '../../../service/helper.service';
import { ExecuteOrderStatus } from '../manage-order.model';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss']
})
export class OrderDetailsComponent implements OnInit {
  orderDetails = null;
  executeOrderStatus = ExecuteOrderStatus;
  orderId: any;

  constructor(private apiService: CustomerManageOrdersService,
    private helper: HelperService,
    public translate: TranslateService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    this.orderId = id;
    this.getDetails(this.orderId)
  }

  getDetails(id) {
    this.apiService.getApprovedOrderDetails(id).subscribe((res: any) => {
      if (res.result && res.data) {
        this.orderDetails = res.data;
      } else {
        this.helper.toggleLoaderVisibility(false);
        swal.fire(
          '',
          this.translate.instant(res.reason),
          'info'
        );
      }
    });
  }

}
